export type SHIFT_MODE = 'start' | 'booking'

export const SHIFT_MODE_VALUES: SHIFT_MODE[] = ['start', 'booking']
